<template>
  <Form ref="carRuleForm" :model="carRule" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="carRule.id" type="hidden"/>

    <FormItem  :label="this.$t('travel.car-rule.plateNo.label')" prop="plateNo">
      <Input v-model="carRule.plateNo" :placeholder="$t('travel.car-rule.plateNo.holder')"/>
    </FormItem>

    <Button
      type="success"
      size="small"
      @click="setNoRule()" style="margin-left: 120px"
    >无规则
    </Button>
    <Button
      type="primary"
      size="small"
      @click="clearRule()" style="margin-left: 10px"
    >清空
    </Button>
    <Button
      type="error"
      size="small"
      @click="addOr()" style="margin-left: 10px"
    >且
    </Button>
    <Button
      type="error"
      size="small"
      @click="addAnd()" style="margin-left: 10px"
    >或
    </Button>
    <br>
    <Button
      type="info"
      size="small"
      @click="setvip()" style="margin-left: 120px;margin-top: 10px"
    >会员检测
    </Button>
    <br>
    <div style="margin-left: 120px;margin-top: 10px">
      <Button
        type="info"
        size="small"
        @click="setbox1()"
      >箱号1
      </Button>
      <Input type="text" style="width: 400px;margin-left: 5px" v-model="box1"
             placeholder="请输入箱号1"></Input>
    </div>
    <br>
    <div style="margin-left: 120px;margin-top: 10px">
      <Button
        type="info"
        size="small"
        @click="setbox2()"
      >箱号2
      </Button>
      <Input type="text" style="width: 400px;margin-left: 5px" v-model="box2"
             placeholder="请输入箱号2"></Input>
    </div>
    <br>
    <div style="margin-left: 120px;margin-top: 10px">
      <Button
        type="info"
        size="small"
        @click="setOverTime()"
      >时间检测
      </Button>
      <DatePicker :value="this.showStartTime" @on-change="setStartTimeFormat" type="datetime" placeholder="请选择开始时间" style="margin-top: 10px"></DatePicker>
      <DatePicker
        :value="this.showEndTime"
        @on-change="setEndTimeFormat"
        type="datetime"
        placeholder="请选择结束时间" style="margin-top: 10px"
      ></DatePicker>
    </div>

    <FormItem  :label="this.$t('travel.car-rule.rule.label')" prop="rule">
      <Input v-model="carRule.rule" :placeholder="$t('travel.car-rule.rule.holder')"  type="textarea" :rows="3" style="margin-top:10px"/>
    </FormItem>

  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      accessCount: 1,
      showStartTime: undefined,
      showEndTime: undefined,
      startTime: undefined,
      box1: "",
      box2: "",
      endTime: undefined,
      carRule: {
        id: null,
        plateNo: null,
        rule: null
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['carRuleForm'].validate(valid => {
        if (valid) {
          if (this.carRule.id) {
            this.updateCarRule(this.carRule).then(then).error(error)
          } else {
            this.createCarRule(this.carRule).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.carRule.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['carRuleForm'].resetFields());
    },
    getCarRule(id,type){
      this.loading = true;
      this.$refs['carRuleForm'].resetFields()
      api.travel.CarRule.detail(id).then(data => {
        this.carRule.id = data.id;
        this.carRule.plateNo = data.plateNo;
        this.carRule.rule = data.rule;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createCarRule(carRule){
      this.loading = true;
      return api.travel.CarRule.add(carRule)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateCarRule(carRule){
      this.loading = true;
      return api.travel.CarRule.update(carRule)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    setbox1() {
      this.carRule.rule = (this.carRule.rule ? this.carRule.rule : "") + "#box1=='" + this.box1 + "'"
    },
    setbox2() {
      this.carRule.rule = (this.carRule.rule ? this.carRule.rule : "") + "#box2=='" + this.box2 + "'"
    },
    setvip() {
      this.carRule.rule = (this.carRule.rule ? this.carRule.rule : "") + "T(com.pangolins.business.utils.AccessExpressUtil).isVip(#plateNo)"
    },
    setOverTime() {
      if (this.startTime == undefined || this.startTime == "" || this.endTime == undefined || this.endTime == "") {
        this.$Message.error("请选择通行时间区间")
        return false;
      };
      if (this.startTime > this.endTime) {
        this.$Message.error("开始/结束时间有误")
        return false;
      }
      this.carRule.rule = (this.carRule.rule ? this.carRule.rule : "") + "T(com.pangolins.business.utils.AccessExpressUtil).isOverTime(" + this.startTime + ", " + this.endTime + ") "
    },
    setNoRule() {
      this.carRule.rule = "true";
    },
  setStartTimeFormat(str, date) {
    var datetime = new Date(str);
    var start = datetime.getTime() + "L";
    this.startTime = start ? start : ""
    this.showStartTime = str ? str : ""
  },
  setEndTimeFormat(str, date) {
    var datetime = new Date(str);
    var end = datetime.getTime() + "L";
    this.endTime = end ? end : ""
    this.showEndTime = str ? str : ""
  },
  clearRule() {
    this.carRule.rule = "";
    this.showStartTime = undefined;
    this.showEndTime = undefined;
    this.startTime = undefined;
    this.endTime = undefined;
    this.box1 = '';
    this.box2 = '';
  },
  addOr() {
    if (this.carRule.rule == undefined || this.carRule.rule == "") {
      this.$Message.error("规则不能为空")
      return false;
    }
    this.carRule.rule += " && ";
  },
  addAnd() {
    if (this.carRule.rule == undefined || this.carRule.rule == "") {
      this.$Message.error("规则不能为空")
      return false;
    }
    this.carRule.rule += " || ";
  }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      plateNo: [{type: 'string', required: true, message: this.$t('travel.car-rule.plateNo.required'),trigger: 'blur'}, {type: 'string',max: 10, message: this.$t('travel.car-rule.plateNo.max'),trigger: 'blur'}],
      rule: [{type: 'string', required: true, message: this.$t('travel.car-rule.rule.required'),trigger: 'blur'}, {type: 'string',max: 1024, message: this.$t('travel.car-rule.rule.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['carRuleForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
